import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.679 21.736 32.54 8.874c.628-.629 1.571.314.943.943L20.15 23.15c-.219.219-.475.247-.69.165a.73.73 0 0 1-.299-.184 14.34 14.34 0 0 0-.428-.455l-6.192-6.193c-.629-.628.314-1.57.942-.942l6.196 6.195Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.679 21.736 25.54 8.874c.628-.629 1.571.314.942.943L13.15 23.15c-.219.219-.475.247-.69.165a.73.73 0 0 1-.299-.184 14.34 14.34 0 0 0-.428-.455L5.54 16.483c-.629-.628.314-1.57.942-.942l6.196 6.195Z",
    fill: "currentColor"
  }));
};

var SvgDoubleCheck = styled(SvgComponent).withConfig({
  displayName: "DoubleCheck__SvgDoubleCheck",
  componentId: "sc-l8axkk-0"
})(["", " ", ""], size, color);
export default SvgDoubleCheck;